import React from "react";
import ReactDOM from 'react-dom/client';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import { HashRouter } from "react-router-dom";
import "./fonts/BloodyTerror.ttf";
import { ChakraProvider } from "@chakra-ui/react";
import { myTheme } from "./theme/theme";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<>
		<ChakraProvider theme={myTheme} >
			<HashRouter>
				<Provider store={store}>
					<App />
				</Provider>
			</HashRouter>
		</ChakraProvider>
	</>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
